// import logo from './logo.svg';
import "./App.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router";
import Checkout from "./Checkout/Checkout";
import Header from "./Common/Header";
import Footer from "./Common/Footer";
import Home from "./Home";
import StoreDetails from "./StoreDetails";
import SpeedBooking from "./SpeedBooking";
import BookingConfirmation from "./BookingConfirmation";
import BookingDetails from "./BookingDetails";
import NotFound from "./Common/NotFound";
import ViewMenu from "./ViewMenu";
import RefTracker from "./Common/RefTracker";
// import Facilities from "./Common/Facilities";
import EventDetails from "./EventDetails/Index";
import ScrollToTop from "./ScrollToTop";
import StoreCheck from "./StoreCheck";
import AppInitializer from "./Common/AppInitializer";
import PayAtTable from "./PayAtTable";

function App() {
  const handleConfigLoaded = (countries) => {
    // Handle post-config loading logic
    // Example: Set default country, navigate, etc.
    if (countries && countries.length > 0) {
      console.log('App configs loaded successfully', countries);
    }
  };

  return (
    <BrowserRouter>
      <StoreCheck>
        <AppInitializer onConfigLoaded={handleConfigLoaded}>
          <div className="App">
            <div className="min-100">
              <Header />
              {/* <BrowserRouter> */}
              <ScrollToTop />
              <RefTracker />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/web/:storeSlug" element={<StoreDetails />} />
                <Route path="/web" element={<Navigate to="/" replace />} />
                {/* <Route path="/event/:storeID" element={<EventDetails />} /> */}
                <Route
                  path="/web/:storeSlug/event/:eventID"
                  element={<EventDetails />}
                />
                <Route path="/web/:storeSlug/book-a-table" element={<Checkout />} />
                <Route path="/web/:storeSlug/menu" element={<ViewMenu />} />
                <Route path="/speed-booking/:storeID" element={<SpeedBooking />} />

                <Route
                  path="/booking-confirmation"
                  element={<BookingConfirmation />}
                />
                <Route path="/booking/:bookingID" element={<BookingDetails />} />
                <Route path="/menu/:storeID" element={<ViewMenu />} />
                <Route path="/pay-at-table" element={<PayAtTable />} />
                <Route path="/pay-at-table/:tableToken" element={<PayAtTable />} />
                <Route path="/pay-at-table/:storeID/:tableNumber" element={<PayAtTable />} />
                <Route path="*" element={<NotFound />} />
                {/* <Checkout /> */}
              </Routes>
              {/* </BrowserRouter> */}
            </div>
            <Footer />
          </div>
        </AppInitializer>
      </StoreCheck>
    </BrowserRouter>
  );
}

export default App;
